<template>
  <v-container fluid>
    <v-form>
      <div class="d-flex flex-column align-center mb-6">
        <v-avatar
          v-if="pickedImg"
          size="100"
          @click="pickFile"
          style="cursor: pointer;"
        >
          <v-img :src="pickedImg" cover></v-img>
        </v-avatar>

        <div
          v-else
          class="file_uploader pa-3"
          :class="[{ '-drag': isDrag === 'new' }]"
          @click="pickFile"
          @dragover.prevent="checkDrag($event, 'new', true)"
          @dragleave.prevent="checkDrag($event, 'new', false)"
          @drop.prevent="onDrop"
        >
          <v-icon color="primary" size="x-large">mdi-camera</v-icon>
        </div>
        
        <input
          class="d-none"
          ref="fileInput"
          type="file"
          @change="onDrop"
          accept=".png,.jpg,image/jpeg,image/png"
        />
        <span v-if="pickedImg" class="text-caption mt-2 text-grey">{{ t('meCreate.tapToChange') }}</span>
      </div>

      <div class="d-flex">
        <div class="mr-1 flex-grow-1">
          <p class="text-body-2 text-blue-grey mb-1">{{ t('meCreate.lastName') }}</p>
          <v-text-field
            v-model="postMeRequest.lastName"
            variant="outlined"
            density="compact"
          ></v-text-field>
        </div>
        <div class="ml-1 flex-grow-1">
          <p class="text-body-2 text-blue-grey mb-1">{{ t('meCreate.firstName') }}</p>
          <v-text-field
            v-model="postMeRequest.firstName"
            variant="outlined"
            density="compact"
          ></v-text-field>
        </div>
      </div>

      <div v-if="false" class="d-flex">
        <div class="mr-1 flex-grow-1">
          <p class="text-body-2 text-blue-grey mb-1">{{ t('meCreate.lastNameKana') }}</p>
          <v-text-field
            v-model="postMeRequest.lastNameKana"
            variant="outlined"
            density="compact"
          ></v-text-field>
        </div>
        <div class="ml-1 flex-grow-1">
          <p class="text-body-2 text-blue-grey mb-1">{{ t('meCreate.firstNameKana') }}</p>
          <v-text-field
            v-model="postMeRequest.firstNameKana"
            variant="outlined"
            density="compact"
          ></v-text-field>
        </div>
      </div>

      <div>
        <p class="text-body-2 text-blue-grey mb-1">{{ t('meCreate.birthDate') }}</p>
        <v-text-field
          v-model="postMeRequest.birth"
          type="date"
          :max="maxDate"
          min="1950-01-01"
          variant="outlined"
          density="compact"
        ></v-text-field>
      </div>

      <div>
        <p class="text-body-2 text-blue-grey mb-1">{{ t('meCreate.bloodType') }}</p>
        <v-text-field
          v-model="postMeRequest.bloodType"
          variant="outlined"
          density="compact"
        ></v-text-field>
      </div>

      <div>
        <p class="text-body-2 text-blue-grey mb-1">{{ t('meCreate.phoneNumber') }}</p>
        <div class="d-flex align-center">
          <v-text-field v-model="tel1" variant="outlined" density="compact" hide-details></v-text-field>
          <span class="mx-2">-</span>
          <v-text-field v-model="tel2" variant="outlined" density="compact" hide-details></v-text-field>
          <span class="mx-2">-</span>
          <v-text-field v-model="tel3" variant="outlined" density="compact" hide-details></v-text-field>
        </div>
      </div>

      <div class="d-flex justify-center mt-8 mb-5">
        <v-btn @click="postMe" color="primary" block size="large" :loading="isSubmitting">
          {{ t('meCreate.submit') }}
        </v-btn>
      </div>
    </v-form>
  </v-container>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

// store
import { meModule } from '@/store/entityModules/me';
import { t } from '@/i18n';

// model
import { PostMeRequest } from '@/model/Me';

interface DataType {
  isSubmitting: boolean;
  imageFile: File | null;
  pickedImg: string;
  isDrag: string;
  tel1: string;
  tel2: string;
  tel3: string;
  postMeRequest: PostMeRequest;
}

export default defineComponent({
  data: (): DataType => ({
    isSubmitting: false, 
    imageFile: null,
    pickedImg: '',
    isDrag: '',
    tel1: '',
    tel2: '',
    tel3: '',
    postMeRequest: {
      firstName: '',
      lastName: '',
      firstNameKana: '',
      lastNameKana: '',
      imageUrl: null,
      birth: null,
      bloodType: null,
      tel: null,
    },
  }),

  computed: {
    // 生年月日の未来日を選択できないようにするための当日の日付
    maxDate(): string {
      return new Date().toISOString().substring(0, 10);
    }
  },

  methods: {
    t,
    pickFile() {
      const fileInput = this.$refs.fileInput as HTMLInputElement;
      fileInput.click();
    },
    checkDrag(event: any, key: string, status: boolean) {
      if (status && event.dataTransfer.types.includes('text/plain')) {
        return false;
      }
      this.isDrag = status ? key : '';
    },
    onDrop(event: any) {
      this.isDrag = '';
      const fileList = event.target.files || event.dataTransfer?.files;
      
      if (!fileList || fileList.length === 0) {
        return false;
      }
      
      const file = fileList[0];
      const fr = new FileReader();
      fr.readAsDataURL(file);
      fr.addEventListener('load', () => {
        this.pickedImg = fr.result as string;
      });
      this.imageFile = file;
    },
    
    async postMe() {
      try {
        this.isSubmitting = true;

        // 1. 電話番号を結合してセット
        const telArr = [this.tel1, this.tel2, this.tel3].filter(Boolean);
        this.postMeRequest.tel = telArr.length === 3 ? telArr.join('-') : null;

        // 2. 画像の処理（※API仕様によってはFileオブジェクトを送信、またはURLを取得する処理が必要）
        // if (this.imageFile) { ... }

        // 3. 送信処理
        const response = await meModule.postMe(this.postMeRequest);
        console.log('送信成功:', response);

        this.$router.replace('/create-family');

      } catch (error) {
        console.error('送信エラー:', error);
        // 必要に応じてエラーメッセージを表示
      } finally {
        this.isSubmitting = false;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@use '../sass/variables.scss';

.file_uploader {
  width: 100px;
  height: 100px;
  border: 3px dashed rgb(var(--v-theme-primary));
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
  background-color: #f9f9f9;
  cursor: pointer;

  &:hover {
    background-color: #f0f0f0;
  }

  &.-drag {
    background-color: rgba(var(--v-theme-primary), 0.2);
    border-style: solid;
  }
}
</style>